module.exports = __webpack_public_path__ + "static/media/logo-hm.eb9dc86a.jpg";